import React from "react";
import { toast } from "sonner";
import { Heart } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useChaseState, toggleChase } from "../lib/chase";

export default function ChaseHeartButton({ card, className = "" }) {
  const { user } = useAuth();
  const chased = useChaseState(card, !!user);

  const handle = async (e) => {
    e.stopPropagation();
    const result = await toggleChase(card);
    if (result === "added") {
      toast.success(`"${card.name}" added to your Chase Deck`);
    } else if (result === "removed") {
      toast.info(`"${card.name}" removed from your Chase Deck`);
    } else if (result === "duplicate") {
      toast.info("Already in your Chase Deck");
    } else if (result === "auth") {
      toast.error("Log in to build your Chase Deck");
    } else {
      toast.error("Couldn't update your Chase Deck");
    }
  };

  return (
    <button
      type="button"
      data-testid={`chase-heart-button-${card.id}`}
      title={chased ? "Remove from your Chase Deck" : "Add to your Chase Deck"}
      onClick={handle}
      className={`w-7 h-7 rounded-full flex items-center justify-center bg-zinc-900 border shadow-lg transition-colors ${chased ? "border-pink-400 text-pink-400" : "border-pink-400/60 text-pink-300 hover:bg-pink-500/20 hover:border-pink-400"} ${className}`}
    >
      <Heart className={`w-3.5 h-3.5 ${chased ? "fill-pink-400" : ""}`} />
    </button>
  );
}
